import React from 'react';
import { Switch } from 'react-router-dom';

import TitleHelmet from 'components/Helmets/TitleHelmet';
import DescriptionHelmet from 'components/Helmets/DescriptionHelmet';
import SidebarContentLayout from 'components/SidebarContentLayout';
import SidebarNav from 'components/SidebarNav';
import DocsHeader from 'components/DocsHeader';
import RouteItem from 'components/RouteItem';
import SiteFooter from 'components/SiteFooter';

import {
  docsRoutes,
  __docsHome,
  __docsGettingStarted,
  __docsGettingStartedRequest,
  __docsGettingStartedResponse,
  __docsGettingStartedAuthentication,
  __docsGettingStartedAuthenticationHttpAuthorizationHeader,
  __docsGettingStartedAuthenticationApiKeyParameter,
  __docsGettingStartedAuthenticationSession,
  __docsGettingStartedBilling,
  __docsGettingStartedRateLimits,
  __docsSapien,
  __docsSapienCore,
  __docsSapienCoreTokenization,
  __docsSapienCorePartsOfSpeech,
  __docsSapienCoreLemmatization,
  __docsSapienCoreSyntaxDependencyTrees,
  __docsSapienCoreSentenceGraph,
  __docsSapienCoreNamedEntityRecognition,
  __docsSapienCoreDisambiguation,
  __docsSapienCoreCoreferenceResolution,
  __docsSapienCoreSentimentAnalysis,
  __docsSapienTransform,
  __docsSapienTransformNounPluralization,
  __docsSapienTransformVerbConjugation,
  __docsSapienTransformAdjectiveTransformation,
  __docsSapienTransformAdverbTransformation,
  __docsSapienNames,
  __docsCortex,
  __docsCortexStructured,
  __docsCortexStructuredEntitySearch,
  __docsCortexStructuredPropertySearch,
  __docsCortexStructuredCategorySearch,
  __docsCortexStructuredEntityAndPropertySearch,
  __docsCortexStructuredNaturalLanguageQA,
  __docsCortexUnstructured,
  __docsLingua,
} from 'pages/docs/routes';

const TITLE_HELMET = <TitleHelmet title="Documentation · Plasticity Natural Language Processing APIs" />;
const DESCRIPTION_HELMET = <DescriptionHelmet description="Developer-friendly documentation to help you get familiar with the Plasticity natural language processing APIs and explore their features." />;

const Docs = () => {
  const sidebarNavItems = [
    __docsHome,
    {
      path: __docsGettingStarted.path,
      nav: __docsGettingStarted.nav,
      children: [
        {
          ...__docsGettingStarted,
          nav: {
            text: 'Overview',
          },
        },
        __docsGettingStartedRequest,
        __docsGettingStartedResponse,
        {
          ...__docsGettingStartedAuthentication,
          children: [
            __docsGettingStartedAuthenticationHttpAuthorizationHeader,
            __docsGettingStartedAuthenticationApiKeyParameter,
            __docsGettingStartedAuthenticationSession,
          ],
        },
        __docsGettingStartedBilling,
        __docsGettingStartedRateLimits,
      ],
    },
    {
      nav: __docsSapien.nav,
      path: __docsSapien.path,
      children: [
        {
          ...__docsSapien,
          nav: {
            text: 'Overview',
          },
        },
        {
          ...__docsSapienCore,
          children: [
            __docsSapienCoreTokenization,
            __docsSapienCorePartsOfSpeech,
            __docsSapienCoreLemmatization,
            __docsSapienCoreSyntaxDependencyTrees,
            __docsSapienCoreSentenceGraph,
            __docsSapienCoreNamedEntityRecognition,
            __docsSapienCoreDisambiguation,
            __docsSapienCoreCoreferenceResolution,
            __docsSapienCoreSentimentAnalysis,
          ],
        },
        {
          ...__docsSapienTransform,
          children: [
            __docsSapienTransformNounPluralization,
            __docsSapienTransformVerbConjugation,
            __docsSapienTransformAdjectiveTransformation,
            __docsSapienTransformAdverbTransformation,
          ],
        },
        __docsSapienNames,
      ],
    },
    {
      nav: __docsCortex.nav,
      path: __docsCortex.path,
      children: [
        {
          ...__docsCortex,
          nav: {
            text: 'Overview',
          },
        },
        {
          ...__docsCortexStructured,
          children: [
            __docsCortexStructuredEntitySearch,
            __docsCortexStructuredPropertySearch,
            __docsCortexStructuredCategorySearch,
            __docsCortexStructuredEntityAndPropertySearch,
            __docsCortexStructuredNaturalLanguageQA,
          ],
        },
        {
          ...__docsCortexUnstructured,
          children: [
          ],
        },
      ],
    },
    __docsLingua,
  ];

  return (
    <>
      {TITLE_HELMET}
      {DESCRIPTION_HELMET}
      <DocsHeader />
      <SidebarContentLayout
        sidebar={(
          <SidebarNav items={sidebarNavItems} />
        )}
        content={(
          <Switch>
            {Object.values(docsRoutes).reverse().map((route) => (
              <RouteItem
                key={route.path}
                {...route}
              />
            ))}
          </Switch>
        )}
      />
      <SiteFooter theme="dark" />
    </>
  );
};

export default Docs;
